var e = document.querySelector("header");
if(e){
    window.onscroll = function scrolledTop() {
        var scrollPosY = window.pageYOffset | document.body.scrollTop;
        var    secNav = document.querySelector(".secondary-nav");

        if ( secNav ) {
            var    secNavHeight = secNav.clientHeight;

            // if (scrollPosY > 0) {
            //     secNav.classList.add("bg");
            // } else if (scrollPosY <= 0) {
            //     secNav.classList.remove("bg");
            // }

            if (window.innerWidth > 768) {
                if (scrollPosY > secNavHeight) {
                    e.classList.add("sticky");
                    e.classList.add("bg");
                } else if (scrollPosY <= secNavHeight) {
                    e.classList.remove("sticky");
                    if (!document.querySelector(".revealed")) {
                        e.classList.remove("bg");
                    }
                }
            } else {
                if (scrollPosY > 30) {
                    e.classList.add("sticky");
                    e.classList.add("bg");
                } else if (scrollPosY <= secNavHeight) {
                    e.classList.remove("sticky");
                    if (!document.querySelector(".revealed")) {
                        e.classList.remove("bg");
                    }
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/components/header.js